import { ViewColumnComponent } from '../../../../view-column.component';
import { Component } from '@angular/core';
import { FormControl, FormGroup } from "@angular/forms";
import { AppConfig } from '../../../../visa';
import { Store } from '@ngrx/store';
import { SubSink } from 'subsink2';
import { BranchSettingsSelectors } from '../../branch-settings-controller/selectors';
import { BranchSettingsStates } from '../../branch-settings-controller/states';
import { BranchSettingsActions } from '../../branch-settings-controller/actions';

interface LocalState {
    deactivateReturn: boolean;
    selectedIndex: number;
    deactivateAdd: boolean;
    deactivateList: boolean;
  }

  @Component({
    selector: 'app-util-default-settlement-method',
    templateUrl: './default-settlement-method.component.html',
    styleUrls: ['./default-settlement-method.component.css']
  })


  export class UtilBranchDefaultSettlementMethodComponent  extends ViewColumnComponent {
    form: FormGroup;
    apiVisa = AppConfig.apiVisa;
    private subs = new SubSink;
    options:any= {'level': 1, 'multiple': true}
    branchGuid;
    constructor(
      private branchSettingsStore: Store<BranchSettingsStates>)
    {
      super();
    }
    ngOnInit(){
      this.form = new FormGroup({
        default_settlement_cash: new FormControl(),
        default_settlement_credit_card: new FormControl(),
        default_settlement_debit_card: new FormControl(),
        default_settlement_voucher: new FormControl(),
        default_settlement_bank_transfer: new FormControl(),
        default_settlement_cheque: new FormControl(),
        default_settlement_others: new FormControl(),
        default_settlement_ewallet: new FormControl(),
        default_settlement_membership_point_currency: new FormControl(),
      })

      this.subs.sink = this.branchSettingsStore.select(BranchSettingsSelectors.selectBranch).subscribe((b:any)=>{
        this.branchGuid = b.guid;
        this.form.patchValue({
          default_settlement_cash:b.default_settlement_method_json?.default_settlement_cash,
          default_settlement_credit_card:b.default_settlement_method_json?.default_settlement_credit_card,
          default_settlement_debit_card:b.default_settlement_method_json?.default_settlement_debit_card,
          default_settlement_voucher:b.default_settlement_method_json?.default_settlement_voucher,
          default_settlement_bank_transfer:b.default_settlement_method_json?.default_settlement_bank_transfer,
          default_settlement_cheque:b.default_settlement_method_json?.default_settlement_cheque,
          default_settlement_others:b.default_settlement_method_json?.default_settlement_others,
          default_settlement_ewallet:b.default_settlement_method_json?.default_settlement_ewallet,
          default_settlement_membership_point_currency:b.default_settlement_method_json?.default_settlement_membership_point_currency,
        })
      })

    }

    onSubmit(){
      this.branchSettingsStore.dispatch(BranchSettingsActions.updateBranchDetails({guid: this.branchGuid, form: this.form}));
    }

    onReset(){
      this.form.patchValue({
        default_settlement_cash: null,
        default_settlement_credit_card: null,
        default_settlement_debit_card: null,
        default_settlement_voucher: null,
        default_settlement_bank_transfer: null,
        default_settlement_cheque: null,
        default_settlement_others: null,
        default_settlement_ewallet: null,
        default_settlement_membership_point_currency: null
      })
    }

  }

